import React, { Component } from 'react';
import styled from 'styled-components';

import ErrorIcon from 'images/ErrorIcon';
import Container from 'partials/Container';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, errorMessage: '' };
    }
  
    componentDidCatch(error, info) {
        this.setState({ hasError: true, errorMessage: error.message || String(error) });
        console.error(`[${this.props.for}]`, error, info.componentStack);
    }
  
    render() {
        if (this.state.hasError) {
            return(
                <Error>
                    <Container medium>
                        <ErrorIcon/>
                        {this.props.for + ' component crashed because of an error'}
                        {this.state.errorMessage && (
                            <ErrorDetail>{this.state.errorMessage}</ErrorDetail>
                        )}
                    </Container>
                </Error>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;

const Error = styled.div`
    margin: 20px 0;
    .container {
        font-family: "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif; 
        font-weight: normal;
        color: #FF5255;
        justify-content: center;
        display:flex;
        flex-direction: column;
        align-items: center;
        svg {
            margin-right:15px;
        }
    }
`;

const ErrorDetail = styled.pre`
    margin-top: 12px;
    max-width: 100%;
    font-size: 12px;
    color: #333;
    white-space: pre-wrap;
    word-break: break-word;
    text-align: left;
`;


// WEBPACK FOOTER //
// ./src/partials/ErrorBoundary.js